(function () {
  function parseMoney(value) {
    if (!value) return 0;
    return parseFloat(String(value).replace(/[^0-9.]/g, '')) || 0;
  }

  function formatMoney(amount) {
    return `$${amount.toFixed(2)}`;
  }

  function getQuantity() {
    const quantityInput = document.querySelector('product-info .quantity__input');
    return parseInt(quantityInput?.value || '1', 10) || 1;
  }

  function getWidgetUnitPrice() {
    const widget = document.querySelector('recharge-subscription-widget');
    const shadow = widget?.shadowRoot;
    if (!shadow) return null;

    const selectedOption = shadow.querySelector('.rc-purchase-option[rc-selected]');
    if (!selectedOption) return null;

    if (selectedOption.classList.contains('rc-purchase-option__subscription')) {
      return selectedOption.querySelector('[part="rc-purchase-option__discounted-price"]')?.textContent.trim() || null;
    }

    return selectedOption.querySelector('[part="rc-purchase-option__price"]')?.textContent.trim() || null;
  }

  function getFallbackUnitPrice() {
    const priceEl = document.querySelector('product-info .price .price-item--regular, product-info .price .price-item--sale');
    return priceEl?.textContent.trim() || null;
  }

  function updateBuyButtonPrice() {
    const button = document.querySelector('.main-pro-btton .product-form__submit');
    if (!button || button.dataset.showPrice !== 'true') return;

    const labelSpan = button.querySelector('span');
    if (!labelSpan) return;

    const baseLabel = button.dataset.defaultLabel || labelSpan.textContent.trim();
    const unitPrice = getWidgetUnitPrice() || getFallbackUnitPrice();

    if (!unitPrice) {
      labelSpan.textContent = baseLabel;
      return;
    }

    const total = parseMoney(unitPrice) * getQuantity();
    labelSpan.textContent = `${baseLabel} — ${formatMoney(total)}`;
  }

  function bindUpdates() {
    updateBuyButtonPrice();

    document.addEventListener('click', (event) => {
      if (
        event.target.closest('.qty-btn') ||
        event.target.closest('recharge-subscription-widget') ||
        event.target.closest('.rc-purchase-option')
      ) {
        requestAnimationFrame(updateBuyButtonPrice);
      }
    });

    document.addEventListener('change', (event) => {
      if (event.target.matches('.quantity__input, .rc-plans-dropdown__select, [name="purchaseOption"]')) {
        updateBuyButtonPrice();
      }
    });

    document.addEventListener('variant:change', updateBuyButtonPrice);
    document.addEventListener('product-info:loaded', updateBuyButtonPrice);
    window.addEventListener('pageshow', updateBuyButtonPrice);

    const widget = document.querySelector('recharge-subscription-widget');
    if (widget?.shadowRoot) {
      const observer = new MutationObserver(() => {
        requestAnimationFrame(updateBuyButtonPrice);
      });

      observer.observe(widget.shadowRoot, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['rc-selected', 'rc-not-selected'],
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindUpdates);
  } else {
    bindUpdates();
  }
})();
